import React from "react";
import { Star } from "lucide-react";

const REVIEWS = [
  {
    rating: 5,
    quote:
      "ProSource has become a reliable source for my lab. Purity documentation is thorough, batch-to-batch consistency has been excellent, and every shipment arrives promptly packaged for cold-chain integrity.",
    author: "Emily R.",
    tag: "Long-Term Researcher",
  },
  {
    rating: 5,
    quote:
      "Batch consistency is what keeps me ordering. Documentation is clear, vials arrive intact with sealed caps, and turnaround has been dependable for every research restock I've placed.",
    author: "Jason M.",
    tag: "Independent Research",
  },
  {
    rating: 5,
    quote:
      "Ordering from ProSource has simplified our lab's supply chain. The catalog covers what we need for benchtop research, and customer support has been quick to answer sourcing questions.",
    author: "Sarah L.",
    tag: "Academic Lab",
  },
  {
    rating: 5,
    quote:
      "What sets ProSource apart is the consistency between batches. Every vial has been impeccably packaged and clearly labeled. As someone meticulous about research inventory, the reliability is exactly what I look for.",
    author: "Dr. Marcus T.",
    tag: "Research Lab",
  },
  {
    rating: 5,
    quote:
      "Customer service has been outstanding and shipping is consistently fast — I've placed multiple orders and every one has arrived discreetly within a few days. The labeling is professional and every shipment feels premium from the moment you open the box.",
    author: "Alex K.",
    tag: "Repeat Buyer",
  },
];

export default function Testimonials() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-24" data-testid="testimonials-section">
      <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
        <div>
          <div className="overline">CLIENT & RESEARCHER FEEDBACK</div>
          <h2 className="font-heading text-3xl sm:text-4xl mt-3 max-w-2xl">
            What clients and researchers say.
          </h2>
        </div>
        <div className="flex items-center gap-3 font-mono-tech">
          <div className="flex">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} size={14} className="text-[#00C3FF]" fill="currentColor" />
            ))}
          </div>
          <span className="text-xs text-[#8A94A6] uppercase tracking-[0.18em]">5.0 Average · 5 Reviews</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
        {REVIEWS.map((r, i) => (
          <article
            key={i}
            data-testid={`testimonial-${i}`}
            className="bg-[#0C0C12] p-8 flex flex-col gap-5 border border-transparent hover:border-[#00C3FF]/30 transition-colors"
          >
            <div className="flex items-center gap-1">
              {Array.from({ length: r.rating }).map((_, idx) => (
                <Star key={idx} size={12} className="text-[#00C3FF]" fill="currentColor" />
              ))}
            </div>
            <p className="text-sm text-white/85 leading-relaxed flex-1">
              <span className="text-[#00C3FF] font-heading text-2xl leading-none mr-1 align-middle">“</span>
              {r.quote}
            </p>
            <div className="pt-4 border-t border-white/5 flex items-baseline justify-between">
              <div className="font-heading text-base text-white">{r.author}</div>
              <div className="overline" style={{ fontSize: 10 }}>{r.tag}</div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
